// extracted by mini-css-extract-plugin
export var title = "ModuleSection2-module--title--14jjy";